exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display:block;\n  border-radius: 3px;\n  margin: 20px 0;\n  /* padding:20px; */\n  box-shadow: 3px 3px 2px #ccc;\n  /* transition: border-color 0.5s ease-out; */\n}\n/* \n:host(.marked) {\n  padding: 19px;\n} */\n\n:host(.inactive) {\n  color: #ccc;\n}\n\n.form-control {\n  display: inline-block;\n  width: 50%;\n}\n\n.display-inline-block {\n  display: inline-block;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Applications/XAMPP/xamppfiles/htdocs/estudos/angular2/animation-course/basic-project/src/app/project/project.component.css
// module id = ../../../../../src/app/project/project.component.css
// module chunks = main